<template>
  <div class="dialog_sueecss_pc">
    <div class="sueecss_box">
      <div class="dialog-close">
        <i class="el-icon-close" @click="() => this.$emit('closeform')"></i>
      </div>
      <div class="tip">
        <img class="sueecss-icon" :src="require('@/assets/images/sueecss-icon.png')" />
        <h4 style="margin-left: 13px">提交成功！</h4>
      </div>
      <div class="title">
        <p>客服人员e小宝将在1个工作日内与您取得联系开通试用哟</p>
      </div>
      <div class="focus">
        <img class="code" :src="require('@/assets/images/code.png')" />
        <p>关注专属顾问</p>
        <p>获取1份数字化报告</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.dialog_sueecss_pc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.45);
}
.dialog-close {
  width: 2.6667rem;
  height: 2.6667rem;
  background: url('../../../../assets/images/trial_dialog_close_bg.png') top right / cover no-repeat;
  position: absolute;
  top: 0;
  right: 0;
}

.sueecss_box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12.2667rem;
  height: 13.3333rem;
  padding: 0 1.3333rem;
  font-size: .3733rem;
  box-shadow: .16rem .16rem .3467rem .2667rem rgba(2, 6, 11, 0.23);
  background: #fff;
  color: #666b80;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  i {
    position: absolute;
    top: .32rem;
    right: .3733rem;
    font-size: .64rem;
    cursor: pointer;
  }
  .tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2.1333rem;
    .sueecss-icon {
      width: 1.6rem;
      height: 1.6rem;
      margin-bottom: .32rem;
    }
    h4 {
      font-size: .48rem;
      color: #32373f;
      font-weight: 700;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }
  .title {
    width: 100%;
    margin-top: .48rem;
    text-align: center;
  }
  .focus {
    margin-top: .96rem;
    margin-bottom: 1.8667rem;
    text-align: center;
    .code {
      width: 3.4667rem;
      height: 3.4667rem;
      margin-bottom: .24rem;
    }
  }
}
</style>
